module.exports = __webpack_public_path__ + "img/npa_logo.20b51016.png";